import { HolidayConfiguration } from "./holiday-configuration";
import { HolidayDivisionArea } from "./holiday-division-area";

export class HolidayList {
    
    id: number = 0;
    description!: string;
    holidayConfigurations: HolidayConfiguration[] = [];
    holidayDivisionAreas: HolidayDivisionArea[] = [];
    
}